import React from 'react';
import BuildMetadataBadge, { formatBuildFooterLabel } from './BuildMetadataBadge';
import BrandTagline from './BrandTagline';
import BrandWord from './BrandWord';
import { IconInfo, IconPin } from './Icons';

/** Global legal + build metadata footer (single canonical location). */
export default function AppLegalFooter() {
  return (
    <footer className="app-legal-footer" data-testid="app-legal-footer">
      <div className="app-legal-footer__section">
        <p className="app-legal-footer__copyright">© Cybertech d.o.o.</p>
        <p className="app-legal-footer__tagline">
          <BrandWord /> · <BrandTagline className="app-legal-footer__brand-tagline" />
        </p>
      </div>
      <div className="app-legal-footer__section app-legal-footer__legal">
        <p className="app-legal-footer__line">
          <IconPin className="app-legal-footer__icon" aria-hidden />
          Put Vile Rustike 6, 21292 Ostrvica, Hrvatska
        </p>
        <p className="app-legal-footer__line">OIB: 62546265824 · MBS: 060443862</p>
      </div>
      <div className="app-legal-footer__section app-legal-footer__build">
        <p className="app-legal-footer__line">
          <IconInfo className="app-legal-footer__icon" aria-hidden />
          <span className="app-legal-footer__build-label">
            Build:{' '}
            <BuildMetadataBadge
              className="build-metadata-badge build-metadata-badge--footer"
              formatLabel={formatBuildFooterLabel}
            />
          </span>
        </p>
      </div>
    </footer>
  );
}
